export interface ComboSnapshot {
  count: number;
  remaining: number;
  duration: number;
  multiplier: number;
}

const DEFAULT_COMBO_DURATION = 5;

export function comboMultiplier(count: number): number {
  if (count >= 10) return 2;
  if (count >= 6) return 1.5;
  if (count >= 3) return 1.25;
  return 1;
}

/** Keeps short kill chains deterministic and independent from rendering. */
export class ComboSystem {
  private count = 0;
  private remaining = 0;
  readonly duration: number;

  constructor(duration = DEFAULT_COMBO_DURATION) {
    this.duration = Number.isFinite(duration) && duration > 0 ? duration : DEFAULT_COMBO_DURATION;
  }

  update(dt: number): void {
    if (!Number.isFinite(dt) || dt <= 0 || this.remaining <= 0) return;
    this.remaining = Math.max(0, this.remaining - dt);
    if (this.remaining === 0) this.count = 0;
  }

  registerKill(): ComboSnapshot {
    this.count = this.remaining > 0 ? this.count + 1 : 1;
    this.remaining = this.duration;
    return this.snapshot;
  }

  reward(baseReward: number): number {
    return Math.max(0, Math.round(baseReward * comboMultiplier(this.count)));
  }

  reset(): void {
    this.count = 0;
    this.remaining = 0;
  }

  get snapshot(): ComboSnapshot {
    return {
      count: this.count,
      remaining: this.remaining,
      duration: this.duration,
      multiplier: comboMultiplier(this.count),
    };
  }
}
